/**
 * @generated SignedSource<<42cdec1c0df333b1174c12f42c577ba5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuyerIncentives_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useCoreBuyerIncentives_item">;
  readonly " $fragmentType": "BuyerIncentives_item";
};
export type BuyerIncentives_item$key = {
  readonly " $data"?: BuyerIncentives_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuyerIncentives_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "buyerId"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyerIncentives_item",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        },
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "buyerId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "useCoreBuyerIncentives_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "60fc4843c8d3db2a47c48bd15d812627";

export default node;
